import {Button, Form} from '@innowise-group/ui-kit';
import {styled} from '@innowise-group/ui-kit';

export const FormContainer = styled(Form.Container)`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const FormContent = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  max-height: 90%;
  justify-content: space-between;
  gap: 1rem;

  @media (max-width: 481px) {
    gap: 0.8rem;
  }
`;

export const FormLayout = styled(Form.Layout)`
  margin: 0;
  padding: 0;

  @media (max-width: 769px) {
    gap: 1.25rem;
  }
`;

export const FormInfoWrapper = styled.div`
  width: 18.75rem;
  max-width: 32.19%;
  min-width: 7.1875rem;
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  gap: 1.875rem;
  padding-top: 0.6875rem;

  @media (max-width: 769px) {
    gap: 1.25rem;
  }
`;

export const LoaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const BookMeetingDatePicker = styled.div<{
  type: 'date' | 'time';
}>`
  box-sizing: border-box;
  position: relative;
  width: 100%;
  height: 50px;
  max-width: 100%;
  display: flex;
  justify-content: center;
  padding: 0 12px 0 20px;
  border-radius: 0.375rem;
  border: ${({theme}) => `1px solid ${theme.palette.specials.meetings.border}`};
  transition: 0.3s;

  @media (max-width: 1190px) {
    min-height: 2.5rem;
    height: 2.5rem;
  }

  @media (max-width: 530px) {
    min-width: 7.1875rem;
    padding: ${({type}) => (type === 'date' ? '0 0.25rem' : '0 8px')};
  }

  & .react-datepicker-wrapper {
    height: 100%;
  }

  & .react-datepicker__input-container {
    height: 100%;
    z-index: 10;
  }

  &.react-datepicker,
  .react-datepicker__time-container,
  .react-datepicker__time-box {
    width: 100%;
    & .react-datepicker__time-box {
      width: 100%;
      margin: 0;
      text-align: left;
    }
  }

  & .react-datepicker,
  .react-datepicker__header,
  .react-datepicker__time {
    background-color: ${({theme}) => theme.palette.generalAlt.background.primary};
    color: ${({theme}) => theme.palette.general.darkGrey[100]};
  }

  & .react-datepicker--time-only {
    width: 100%;
  }

  & .react-datepicker-popper {
    width: ${({type}) => (type === 'date' ? '270px' : '90%')};
    z-index: 1000;

    @media (max-width: 769px) {
      width: ${({type}) => (type === 'date' ? '270px' : '70%')};
    }
  }

  &
    .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item:hover {
    background-color: ${({theme}) => theme.palette.specials.meetings.backTimeList};
  }

  &
    .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item.react-datepicker__time-list-item--selected:hover {
    background-color: ${({theme}) => theme.palette.general.smart};
  }

  &
    .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item--disabled {
    color: ${({theme}) => theme.palette.general.lightGrey[80]};
  }

  & .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::before,
  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::after {
    border-bottom-color: ${({theme}) => theme.palette.general.lightGrey[100]};
  }

  & .react-datepicker__current-month,
  .react-datepicker-time__header,
  .react-datepicker-year-header,
  .react-datepicker__day-name,
  .react-datepicker__day,
  .react-datepicker__time-name {
    color: ${({theme}) => theme.palette.general.darkGrey[100]};
  }

  & .react-datepicker__day--selected {
    background-color: ${({theme}) => theme.palette.general.smart};
    color: ${({theme}) => theme.palette.general.white};
    border-radius: 0.3rem;
  }

  & .react-datepicker__day--disabled,
  .react-datepicker__month-text--disabled,
  .react-datepicker__quarter-text--disabled,
  .react-datepicker__year-text--disabled {
    color: ${({theme}) => theme.palette.general.lightGrey[80]};
  }

  &
    .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item--selected {
    background-color: ${({theme}) => theme.palette.general.smart};
    color: ${({theme}) => theme.palette.general.white};
  }

  & .react-datepicker__time-list {
    &::-webkit-scrollbar {
      height: 0.625rem;
      width: 0.625rem;
    }

    &::-webkit-scrollbar-track,
    &::-webkit-scrollbar-corner {
      background: ${({theme}) => theme.palette.generalAlt.scrollbar.track};
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 0.625rem;
      background: ${({theme}) => theme.palette.generalAlt.scrollbar.thumb};
      border: 0.125rem solid ${({theme}) => theme.palette.generalAlt.scrollbar.track};
    }

    &::-webkit-scrollbar-thumb:hover {
      background: ${({theme}) => theme.palette.general.lightGrey[80]};
    }
  }
  & .react-datepicker__month-container {
    width: 100%;
  }

  & .react-datepicker__current-month {
    text-transform: capitalize;
  }

  & .react-datepicker__day-names {
    text-transform: capitalize;
    padding: 0 0.4rem;
  }

  & .react-datepicker__day-name,
  .react-datepicker__day {
    width: 1.5rem;
    line-height: 1.625rem;
    padding: 0.3125rem;
    margin: 0 0.0625rem;
  }

  & .react-datepicker__day--today {
    position: relative;
  }

  & .react-datepicker__day--today::after {
    position: absolute;
    content: '';
    inset: 0;
    border: 2px solid black;
    border-radius: 0.3rem;
  }

  & .react-datepicker__day {
    &:hover {
      background-color: rgba(0, 0, 0, 0.1);
    }
  }

  & .popper {
    padding-top: 0.375rem;
  }

  & .react-datepicker__time-list-item {
    display: flex;
    align-items: center;
    padding: 0.3125rem 0.625rem 0.3125rem 12px;
  }
`;

export const FormBtn = styled(Button)`
  height: 50px;
  min-width: 6.25rem;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: flex-end;
  border-radius: 0.5rem;
  padding: 0 1.5rem;

  @media (max-width: 993px) {
    margin: 0;
    height: 2.5rem;
    padding: 0 0.9375rem;
    width: 6.25rem;
  }

  @media (max-width: 481px) {
    height: 1.875rem;
    font-size: 0.8rem;
    padding: 0 0.5rem;
  }
`;
